import request from '@/utils/request'

const goodsEvaluation = {
  name: 'goodsEvaluation',
  state: {
    isGoodsEvaluationDetailLoading: false,
    goodsEvaluationDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_GOODSEVALUATION_DETAIL_LOADING: (state, data) => {
      state.isGoodsEvaluationDetailLoading = data
    },
    SET_MODULES_GOODSEVALUATION_DETAIL_DATA: (state, data) => {
      state.goodsEvaluationDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryGoodsEvaluationDetailData({ commit }, id) {
      commit('SET_IS_MODULES_GOODSEVALUATION_DETAIL_LOADING', true)
      commit('SET_MODULES_GOODSEVALUATION_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/goodsEvaluation/goodsEvaluationDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_GOODSEVALUATION_DETAIL_LOADING', false)
          commit('SET_MODULES_GOODSEVALUATION_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_GOODSEVALUATION_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetGoodsEvaluationDetailData({ commit }) {
      commit('SET_MODULES_GOODSEVALUATION_DETAIL_DATA', {})
    },
    //  重置账号新增页面数据
    setGoodsEvaluationDetailData({ commit }, data) {
      commit('SET_MODULES_GOODSEVALUATION_DETAIL_DATA', data)
    }
  }
}

export default goodsEvaluation
